import { z } from 'zod';

// Stati del job di elaborazione
export type StatoElaborazione = 'IN_CORSO' | 'COMPLETATO' | 'ERRORE' | 'ERRORE_IMPORT' | 'IMPORTATO';

export const StatoElaborazioneSchema = z.enum(['IN_CORSO', 'COMPLETATO', 'ERRORE', 'ERRORE_IMPORT', 'IMPORTATO']);

export const CaricamentoCassaSchema = z.object({
  id: z.number(),
  codice_cassa: z.string().min(1),
  codice_fenice: z.number().int().positive(),
  anno: z.number(),
  mese: z.number(),
  stato: StatoElaborazioneSchema.default('IN_CORSO'),
  nome_tabella: z.string().nullable(),
  stats_json: z.string().nullable(),       // JSON.stringify di ElaboraCassaResult.stats
  warnings_json: z.string().nullable(),    // JSON.stringify di warnings[]
  errore: z.string().nullable(),           // messaggio errore se stato=ERRORE
  import_json: z.string().nullable(),      // JSON.stringify di ImportResult
  file_path: z.string().nullable(),        // path CSV generato
  importato_at: z.string().nullable(),     // DATETIME import completato
  // NULL = cassa mono-tipo (default); valore = codice tipo (ISCRITTI/ALTRI/TUTTI...)
  tipo: z.string().nullable(),
  created_at: z.string().optional(),
});

export type CaricamentoCassa = z.infer<typeof CaricamentoCassaSchema>;

export type CaricamentoCassaInsert = {
  codice_cassa: string;
  codice_fenice: number;
  anno: number;
  mese: number;
  stato?: StatoElaborazione;
  nome_tabella?: string | null;
  stats_json?: string | null;
  warnings_json?: string | null;
  errore?: string | null;
  import_json?: string | null;
  file_path?: string | null;
  importato_at?: string | null;
  tipo?: string | null;
};

// Allineamento archivi (mono-tipo auto, multi-tipo manuale). Una riga per
// (cassa, anno, mese); `origine` discrimina i due flussi e abilita UNDO
// solo sul manuale.
export const AllineamentoArchivioSchema = z.object({
  id: z.number(),
  codice_cassa: z.string().min(1),
  anno: z.number(),
  mese: z.number(),
  eseguito_at: z.string(),
  eseguito_da: z.string().nullable(),
  origine: z.enum(['auto', 'manuale']),
  n_cessate_implicite: z.number().int().nonnegative(),
  n_lavoratori_periodo: z.number().int().nonnegative(),
  n_lavoratori_periodo_prec: z.number().int().nonnegative(),
  note: z.string().nullable(),
});

export type AllineamentoArchivio = z.infer<typeof AllineamentoArchivioSchema>;

export type AllineamentoArchivioInsert = {
  codice_cassa: string;
  anno: number;
  mese: number;
  eseguito_da?: string | null;
  origine: 'auto' | 'manuale';
  n_cessate_implicite: number;
  n_lavoratori_periodo: number;
  n_lavoratori_periodo_prec: number;
  note?: string | null;
};
